// Unpublished Work © 2026 Deere & Company.

export const INVALID_RESPONSE_CODE = 'Invalid response code';

export const DOWNLOAD_ERROR_DETAILED =
    'Error: Must be a member of security group for DOWNLOAD_QA_SOFTWARE_MANAGER (UPCREPOQ AD group)';

export const DOWNLOAD_ERROR_GENERIC = "Error: You don't have access to this download. Contact your administrator.";
